import { MouseEventHandler } from 'react';
import {
  InputText as PrimeInputText,
  InputTextProps as PrimeInputTextProps,
} from 'primereact/inputtext';

/**
 * Props for ComponentsFilter
 */
type ComponentsFilterProps = PrimeInputTextProps & {
  onClear: MouseEventHandler<HTMLButtonElement>;
};

/**
 * Filter component for application components
 * @param props The props for the component
 */
export const ComponentsFilter = (props: ComponentsFilterProps) => {
  return (
    <div style={{ position: 'relative', width: '40%' }}>
      <PrimeInputText
        {...props}
        style={{
          ...props.style, // Preserve any existing styles passed via props
          paddingRight: '32px', // Add padding to make space for the button
          width: '100%', // Ensure the input takes the full width of the container
        }}
      />
      {props.value && (
        <button
          onClick={props.onClear}
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            fontSize: '16px',
            position: 'absolute',
            right: '8px',
            top: '50%',
            transform: 'translateY(-50%)',
          }}
          title="Clear"
        >
          ✕
        </button>
      )}
    </div>
  );
};
